import { api } from "@/api/axios.ts";
import {
  ApiTask,
  ApiTaskAction,
  ApiTaskCommentFilter,
  ApiTaskCommentPayload,
  ApiTaskEmployeeRole,
  ApiTaskFilter,
  ApiTaskPayload,
} from "@/types/task.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiComment } from "@/types/comment.types.ts";

export const apiEmployeeTask = {
  getMyTodo() {
    return api.get<ApiTask[]>("/api/v1/employees/tasks/my/todo");
  },
  getByEmployeeTodo(employeeId: number, role: ApiTaskEmployeeRole) {
    return api.get<ApiTask[]>(`/api/v1/employees/${employeeId}/tasks/${role}/todo`);
  },
  searchMy(filter: ApiTaskFilter) {
    return api.post<ApiPagedData<ApiTask>>("/api/v1/employees/tasks/my/search", filter);
  },
  searchByEmployee(employeeId: number, role: ApiTaskEmployeeRole, filter: ApiTaskFilter) {
    return api.post<ApiPagedData<ApiTask>>(
      `/api/v1/employees/${employeeId}/tasks/${role}/search`,
      filter
    );
  },
  getById(taskId: number) {
    return api.get<ApiTask>(`/api/v1/tasks/${taskId}`);
  },
  getActions(taskId: number) {
    return api.get<ApiTaskAction[]>(`/api/v1/tasks/${taskId}/actions`);
  },
  create(payload: ApiTaskPayload) {
    return api.post<ApiTask>("/api/v1/tasks", payload);
  },
  update(taskId: number, payload: ApiTaskPayload) {
    return api.put<ApiTask>(`/api/v1/tasks/${taskId}`, payload);
  },
  archive(taskId: number) {
    return api.delete<ApiOperationResult>(`/api/v1/tasks/${taskId}`, {});
  },
  complete(taskId: number) {
    return api.post<ApiOperationResult>(`/api/v1/tasks/${taskId}/complete`, {});
  },
  uncomplete(taskId: number) {
    return api.post<ApiOperationResult>(`/api/v1/tasks/${taskId}/uncomplete`, {});
  },
  start(taskId: number) {
    return api.post<ApiTask>(`/api/v1/tasks/${taskId}/start`, {});
  },
  stop(taskId: number) {
    return api.post<ApiTask>(`/api/v1/tasks/${taskId}/stop`, {});
  },
  searchComments(taskId: number, filter: ApiTaskCommentFilter, signal: AbortSignal) {
    return api.post<ApiPagedData<ApiComment>>(
      `/api/v1/tasks/${taskId}/comments/search`,
      filter,
      signal
    );
  },
  createComment(taskId: number, payload: ApiTaskCommentPayload) {
    return api.post<ApiComment>(`/api/v1/tasks/${taskId}/comments`, payload);
  },
  updateComment(taskId: number, commentId: number, payload: ApiTaskCommentPayload) {
    return api.put<ApiComment>(`/api/v1/tasks/${taskId}/comments/${commentId}`, payload);
  },
  deleteComment(taskId: number, commentId: number) {
    return api.delete<ApiOperationResult>(`/api/v1/tasks/${taskId}/comments/${commentId}`, {});
  },
};
